import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import CategorySection from "./components/Category/CategorySection";
import Favourite from "./components/Favourites/favourite";
import ItemPreview from "./components/Items/itemPreview";
import ItemsSection from "./components/Items/ItemsSection";
import Nav from "./components/nav";
import PreviewPage from "./previewPage";
import SearchCategory from "./components/searchSection";
import SideNav from "./components/sideNav";
import useInitialize from "./main";
import View from "./components/vieworder/view";
import ViewItems from "./components/viewitems/view";
import Waiter from "./components/waiterCall/waiter";
import { motion } from "framer-motion";
import ReactLoading from "react-loading";
import { Review } from "./components/Review/Review";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { UserActions } from "./store/user";

function App() {
  const dispatch = useDispatch();
  const { getTokenDetails } = useInitialize();
  const showSection = useSelector((state) => state.EMenu.showSection);
  const itemPreview = useSelector((state) => state.EMenu.itemPreview);
  const item_search = useSelector((state) => state.EMenu.item_search);
  const review = useSelector((state) => state.EMenu.review);
  const viewOrder = useSelector((state) => state.EMenu.viewOrder);
  const viewItems = useSelector((state) => state.EMenu.viewItems);
  const favouritePage = useSelector((state) => state.EMenu.favouritePage);
  const waiterCall = useSelector((state) => state.EMenu.waiterCall);
  const bgImg = useSelector((state) => state.Company.bg_image);
  const bg_img = localStorage.getItem("backgroundLoaded") || bgImg;

  useEffect(() => {
    getTokenDetails();
    dispatch(UserActions.setUserName(localStorage.getItem("name") || ""));
    dispatch(UserActions.setUserPhone(localStorage.getItem("phone") || ""));
  }, []);
  return (
    <div className="md:grid md:grid-cols-6" >
      <div
        className={`md:col-span-2 md:block ${
          showSection === false &&
          viewOrder === false &&
          favouritePage === false
            ? "max-md:block"
            : "max-md:hidden"
        }`}
      >
        {bg_img ? (
          <SideNav />
        ) : (
          <div className="h-[100vh] bg-[#ccc] grid items-center max-md:p-10 md:p-10 xl:p-20">
            <div className="sm:w-[70%] w-[50%] m-auto">
              <ReactLoading
                type={"spin"}
                color={"#fff"}
                height={"100%"}
                width={"100%"}
              />
            </div>
          </div>
        )}
      </div>
      <div className={`md:col-span-4 md:block`}>
        {/* ${showSection === true || viewOrder === true || favouritePage === true ? "md:block" : "md:hidden"}`} */}
        {viewOrder ? (
          <motion.div
          // initial={{ opacity: 0, x: 150 }}
          // animate={{ opacity: 1, x: 0 }}
          //   transition={{ duration: 0.5 }}
          >
            <View />
          </motion.div>
        ) : null}
        <motion.div>{favouritePage ? <Favourite /> : null}</motion.div>
        {showSection === true ? (
          <motion.div>
            <Nav />
            <CategorySection />
            {item_search ? <SearchCategory /> : <ItemsSection />}
            {itemPreview === true ? <ItemPreview /> : ""}
          </motion.div>
        ) : (
          <PreviewPage />
        )}
      </div>
      {review ? <Review /> : null}
      {viewItems ? <ViewItems /> : null}
      {waiterCall ? <Waiter /> : null}
      <ToastContainer />
    </div>
  );
}

export default App;
